import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Floating circular "back to top" button that appears after
// the user scrolls down. Styled with the brand gradient.
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      onClick={scrollTop}
      aria-label="Back to top"
      data-testid="back-to-top"
      className={`fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full grid place-items-center text-black shadow-[0_10px_30px_-8px_rgba(244,133,30,0.7)] transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      style={{
        background: "linear-gradient(135deg, #ffb870 0%, #f4851e 50%, #c45e00 100%)",
      }}
    >
      <ArrowUp size={18} strokeWidth={2.5} />
    </button>
  );
}
